import edit from "@Images/NewUI/edit.png";
import security_m from "@Images/NewUI/security_m.png";
import "@Styles/mandate.css";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import OtpInput from "react-otp-input";
import { Form } from "semantic-ui-react";
import Heading from "../../Common/MainHeading";
import { HEADING_SECURITY_PRIVACY } from "../../Common/constant";

const SecurityPrivacy = (props) => {
  const [isshow, setIsShow] = useState(false);
  const otpClose = () => setIsShow(false);
  const otpShow = () => setIsShow(true);
  return (
    <div className="main_div">
      <div className="container">
        <div className="pb-4">
          <Heading
            headingText={HEADING_SECURITY_PRIVACY}
            backprops={"/DummyDashboard"}
            history={props.history}
          />
          <div className="reset_mm flex space-between align-center">
            <div className="flex align-center">
              <img src={security_m} alt="security_m" />
              <span>MPIN</span>
            </div>
            <a href="/change_mpin">
              <span className="change_icon" onClick={otpShow}>
                <img src={edit} alt="edit" style={{ marginRight: "8px" }} />
                Change
              </span>
            </a>
          </div>
        </div>
      </div>
      <Modal show={isshow} onHide={otpClose} className="modal_flex modal_sp">
        <Modal.Body>
          <div className="popup-div">
            <span className="heading-pop">Enter MPIN to validate</span>
            <Form>
              <Form.Field>
                <div>
                  <OtpInput
                    containerStyle="otpCover"
                    numInputs={6}
                    inputType="number"
                    renderSeparator={<span></span>}
                    renderInput={(props) => <input {...props} />}
                  />
                </div>
              </Form.Field>
            </Form>
          </div>
          <div className="button-wrapper text-center">
            <a
              className="btn bg-orange text-white rounded-pill"
              onClick={otpClose}
            >
              Confirm
            </a>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SecurityPrivacy;
